import { Button, FormField, Input, Stack } from '@volee/ui'

import { FormError } from '@volee/forms'
import { NewPasswordFields } from './password-fields.tsx'
import type { AuthFormProps, ResetConfirmFields, ResetRequestFields } from '../data/auth-fields.ts'
import { messages } from '../messages/index.ts'

// The two steps of /forgot-password. Step one never says whether the account exists, and
// step two is re-enterable: a reload goes back to asking for a code, which is harmless.

export function ResetRequestForm({
  form,
  submit,
  pending,
  formError,
}: AuthFormProps<ResetRequestFields>) {
  const { register, formState } = form

  return (
    <form noValidate onSubmit={form.handleSubmit(submit)}>
      <Stack gap="md">
        <FormError message={formError} />

        <FormField
          label={messages.passwordReset.email}
          error={formState.errors.email?.message}
          required
        >
          {(props) => (
            <Input
              {...props}
              {...register('email')}
              type="email"
              autoComplete="username"
              disabled={pending}
            />
          )}
        </FormField>

        <Button type="submit" loading={pending}>
          {messages.passwordReset.request}
        </Button>
      </Stack>
    </form>
  )
}

export function ResetConfirmForm({
  form,
  submit,
  pending,
  formError,
}: AuthFormProps<ResetConfirmFields>) {
  const { register, formState } = form

  return (
    <form noValidate onSubmit={form.handleSubmit(submit)}>
      <Stack gap="md">
        <FormError message={formError} />

        <FormField
          label={messages.passwordReset.code}
          error={formState.errors.code?.message}
          required
        >
          {(props) => (
            <Input
              {...props}
              {...register('code')}
              inputMode="numeric"
              autoComplete="one-time-code"
              disabled={pending}
            />
          )}
        </FormField>

        <NewPasswordFields
          newPassword={register('newPassword')}
          confirmPassword={register('confirmPassword')}
          errors={{
            newPassword: formState.errors.newPassword?.message,
            confirmPassword: formState.errors.confirmPassword?.message,
          }}
          pending={pending}
        />

        <Button type="submit" loading={pending}>
          {messages.passwordReset.confirm}
        </Button>
      </Stack>
    </form>
  )
}
